import {
    Component,
    EventEmitter,
    Input,
    Output,
    TemplateRef,
    ChangeDetectionStrategy
} from "@angular/core";
import { ISearchResponseRow, ISearchResultRenderer } from "../../quick-search.models";
import { ButtonComponent } from "../../../button/button.component";

@Component({
    selector: "rask-no-result-show-navet-renderer",
    templateUrl: "./no-result-show-navet-renderer.component.html",
    styleUrls: ["./no-result-show-navet-renderer.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ButtonComponent]
})
export class NoResultShowNavetRendererComponent implements ISearchResultRenderer {

    @Input() input: ISearchResponseRow;
    @Input() tooltipTemplate: TemplateRef<any>;
    @Output() searchExtended = new EventEmitter<any>();

    extendedNavetSearch(event?: MouseEvent) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.searchExtended.emit();
    }
}
